module.exports = __webpack_public_path__ + "static/media/speakers.2ca2dcc9.svg";